/**
 * R-Series uses `0` / `'0'` when a customer has no credit account yet.
 * WC hosts and balance drift fetches should stay on the parcel path until a
 * real credit account id exists.
 */
export function hasCreditAccountId(creditAccountId: string | number | null | undefined): boolean {
  if (creditAccountId === null || creditAccountId === undefined) {
    return false;
  }

  const normalized = String(creditAccountId).trim();
  return normalized.length > 0 && normalized !== '0';
}
